<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
    name: 'SecondaryButton',

    props: {
        btnTxt: {
            type: String,
            required: true
        }
    },

    emits: ['on-click']
})
</script>

<template>
    <button
        @click="$emit('on-click')"
        class="px-5 py-2.5 rounded-lg border border-gray-300 text-gray-700 font-medium hover:bg-gray-100 transition cursor-pointer">
        {{btnTxt}}
    </button>
</template>